<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh">
            <Col :xs="20" :md="18" :xl="12">
                <Card class="shadow">
                    <Row align="middle">
                        <Col :xs="24" :md="{ span: 16, offset: 4 }">
                            <h class="text-center text-22">{{ $t("views.accountLayout.title") }}</h>
                        </Col>
                        <Col :xs="24" :md="12" class="p-3">
                            <img class="max-w-100 img-center d-flex" alt="brand" v-if="brandUrl" :src="brandUrl" />
                        </Col>
                        <Col :xs="24" :md="12" class="p-3">
                            <router-view :key="$route.path"></router-view>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
import { computed, defineComponent } from "vue";
import {} from "./account-layout.logic";
import { getBrandUrl } from "../../../app.logic";
import { Layout, Row, Col, Card } from "ant-design-vue";

export default defineComponent({
    components: {
        Layout,
        Row,
        Col,
        Card,
    },
    setup() {
        const brandUrl = computed(() => getBrandUrl());
        return { brandUrl };
    },
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
</style>
